// src/components/Redirect.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';

export const Redirect = ({ children }) => {
    const { status } = useAuth();
    const location = useLocation();

    if (status === 'authenticated') {
        const to = location.state?.from?.pathname || sessionStorage.getItem('redirectAfterLogin') || '/';
        return <Navigate to={to} replace />;
    }
    if (status === 'loading') {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                <div className="spinner-border" role="status" aria-label="Loading..." />
            </div>
        );
    }
    return children;
};
